/**
 * Apply configured web-play CSS files as native stylesheets in their declared order.
 * Returns the inserted links so callers with a lifecycle can remove them.
 */
export function addWebPlayCustomCss(customCssFiles: string | null): HTMLLinkElement[] {
  const stylesheetLinks: HTMLLinkElement[] = []
  const cssUrls = customCssFiles
    ?.split(/[\n,]+/)
    .map(url => url.trim())
    .filter(isValidUrl)

  for (const cssUrl of cssUrls ?? []) {
    const link = document.createElement('link')
    link.rel = 'stylesheet'
    link.href = cssUrl
    link.dataset.webPlayCustomCss = cssUrl
    link.addEventListener('error', () => console.error(`Failed to load custom CSS: ${cssUrl}`), { once: true })

    document.head.appendChild(link)
    stylesheetLinks.push(link)
  }

  return stylesheetLinks
}

function isValidUrl(href: string): boolean {
  try {
    new URL(href)
    return true
  } catch {
    return false
  }
}
